import { SortOrders } from "./types";

export function defaultValueGetter<T extends Record<string, unknown>>(
  row: T,
  id: string
) {
  return row[id];
}

// Compares two strings
export const stringComparator = (
  a: string,
  b: string,
  direction: SortOrders
): number => {
  if (a > b) return direction === SortOrders.ASC ? 1 : -1;
  if (a < b) return direction === SortOrders.ASC ? -1 : 1;
  return 0;
};

// Compares two numbers
export const numberComparator = (
  a: number,
  b: number,
  direction: SortOrders
): number => {
  return direction === SortOrders.ASC ? a - b : b - a;
};

// Compares two numbers
export const numberArrayComparator = (
  a: string,
  b: string,
  direction: SortOrders
): number => {
  let total = 0;
  //  @ts-ignore
  const aMatches = [...a.matchAll(/\d+/g)];
  //  @ts-ignore
  const bMatches = [...b.matchAll(/\d+/g)];

  if (aMatches.length !== bMatches.length) {
    return direction === SortOrders.ASC
      ? aMatches.length - bMatches.length
      : bMatches.length - aMatches.length;
  } else {
    aMatches.forEach((a, index) => {
      total += numberComparator(+a[0], +bMatches[index][0], direction);
      console.log(+a[0], +bMatches[index][0], total);
    });
  }
  return total;
};
